const schema = require('~/src/stock/data/stockChecks/schema')

module.exports = schema
